webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(33);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(3);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VueResource = __webpack_require__(58);
	
	_vue2.default.use(VueResource);
	
	new _vue2.default({
		router: _router2.default,
		el: '#app',
		template: '<App/>',
		components: { App: _App2.default }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(26)
	
	/* script */
	__vue_exports__ = __webpack_require__(15)
	
	/* template */
	var __vue_template__ = __webpack_require__(51)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-3bcacc19"
	
	module.exports = __vue_exports__


/***/ },
/* 2 */,
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(2);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(59);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _home = __webpack_require__(40);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _team = __webpack_require__(42);
	
	var _team2 = _interopRequireDefault(_team);
	
	var _websiteDevelopment = __webpack_require__(44);
	
	var _websiteDevelopment2 = _interopRequireDefault(_websiteDevelopment);
	
	var _frontEndOutsourcing = __webpack_require__(39);
	
	var _frontEndOutsourcing2 = _interopRequireDefault(_frontEndOutsourcing);
	
	var _technologies = __webpack_require__(43);
	
	var _technologies2 = _interopRequireDefault(_technologies);
	
	var _projects = __webpack_require__(41);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _contactus = __webpack_require__(38);
	
	var _contactus2 = _interopRequireDefault(_contactus);
	
	var _careers = __webpack_require__(37);
	
	var _careers2 = _interopRequireDefault(_careers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
		linkActiveClass: 'active',
		routes: [{ path: '/', redirect: '/home' }, { path: '/home', name: 'home', component: _home2.default, meta: { linkText: 'Home' } }, { path: '/website-development', name: 'websiteDevelopment', component: _websiteDevelopment2.default, meta: { linkText: 'Website Development' } }, { path: '/front-end-outsourcing', name: 'frontEndOutsourcing', component: _frontEndOutsourcing2.default, meta: { linkText: 'Front End Outsourcing' } }, { path: '/team', name: 'team', component: _team2.default, meta: { linkText: 'Team' } }, { path: '/technologies', name: 'technologies', component: _technologies2.default, meta: { linkText: 'Technologies' } }, { path: '/projects', name: 'projects', component: _projects2.default, meta: { linkText: 'Projects' } }, { path: '/careers', name: 'careers', component: _careers2.default, meta: { linkText: 'Careers' } }, { path: '/contactus', name: 'contactus', component: _contactus2.default, meta: { linkText: 'Contact Us' } }]
	});
	
	exports.default = router;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _appHeader = __webpack_require__(35);
	
	var _appHeader2 = _interopRequireDefault(_appHeader);
	
	var _appSidebar = __webpack_require__(36);
	
	var _appSidebar2 = _interopRequireDefault(_appSidebar);
	
	var _appFooter = __webpack_require__(34);
	
	var _appFooter2 = _interopRequireDefault(_appFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'app',
		components: {
			appHeader: _appHeader2.default,
			appSidebar: _appSidebar2.default,
			appFooter: _appFooter2.default
		},
		data: function data() {
			return {
				companyName: 'Weboko',
				companyDesc: 'Web Development'
			};
		}
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'appFooter',
		props: ['name', 'desc'],
		data: function data() {
			return {};
		}
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'appHeader',
		props: ['name', 'desc'],
		data: function data() {
			return {};
		}
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'appSidebar',
		props: [],
		data: function data() {
			return {
				tags: [{ name: 'Development', link: 'home' }, { name: 'Front-End', link: 'home' }, { name: 'Mobile App', link: 'home' }, { name: 'CMS', link: 'website-development' }, { name: 'Angular 2.0', link: 'technologies' }, { name: 'Vue.js', link: 'technologies' }, { name: 'Webpack', link: 'technologies' }, { name: 'Node.js', link: 'technologies' }, { name: 'React', link: 'technologies' }, { name: 'Git', link: 'technologies' }, { name: 'Polymer', link: 'technologies' }, { name: 'HTML5', link: 'technologies' }, { name: 'Website', link: 'website-development' }, { name: 'Outsourcing', link: 'front-end-outsourcing' }]
			};
		}
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'careers',
		data: function data() {
			return {};
		}
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(17);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'contactUs',
	
		methods: {
			submitForm: function submitForm() {
				var _this = this;
	
				var body = '<h1>Weboko</h1>\n\t\t\t\t<table cellspacing="0" cellpadding="5" border="1">\n\t\t\t\t\t<tr><td><strong>Sender</strong></td><td>' + this.mail.name + '</td></tr>\n\t\t\t\t\t<tr><td><strong>Phone</strong></td><td>' + this.mail.phone + '</td></tr>\n\t\t\t\t\t<tr><td><strong>Email</strong></td><td>' + this.mail.email + '</td></tr>\n\t\t\t\t\t<tr><td><strong>Sender</strong></td><td>' + this.mail.name + '</td></tr>\n\t\t\t\t\t<tr><td><strong>Message</strong></td><td>' + this.mail.message + '</td></tr>\n\t\t\t\t</table>';
				var mail = {
					'to': this.mail.to,
					'subject': 'Weboko-form',
					'sendername': this.mail.name,
					'html': body
				};
				this.$http.post('https://weboko-f1a8.restdb.io/mail', (0, _stringify2.default)(mail), {
					'crossDomain': true,
					headers: {
						'x-apikey': '58a99c61f1f38218353a09d4',
						'content-type': 'application/json',
						'cache-control': 'no-cache'
					}
				}).then(function (data) {
					_this.mail.error = false;
					_this.mail.thankyou = true;
					console.log('Contact data: ', data);
				}, function (err) {
					_this.mail.error = true;
					setTimeout(function () {
						_this.mail.error = false;
					}, _this.mail.errorDelay);
					console.log('Contact error: ', err);
				});
			}
		},
	
		data: function data() {
			return {
				mail: {
					to: 'info@weboko.co.il',
					name: '',
					phone: '',
					message: '',
					thankyou: false,
					error: false,
					errorDelay: 10000
				}
			};
		}
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'frontEndOutsourcing',
		methods: {
			toggleCollapse: function toggleCollapse(collapse) {
				if (collapse) {
					this[collapse] = !this[collapse];
				}
			}
		},
		data: function data() {
			return {
				collapseA: false
			};
		}
	};

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'home',
		data: function data() {
			return {};
		}
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _viewPortfolio = __webpack_require__(1);
	
	var _viewPortfolio2 = _interopRequireDefault(_viewPortfolio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'projects',
		components: {
			viewPortfolio: _viewPortfolio2.default
		},
		data: function data() {
			return {
				currentPage: 0,
				itemsPerPage: 6,
				projects: [{ name: 'beithakochav', image: 'static/images/projects/bh.jpg', caption: 'Beit Hakochav', desc: 'Website', link: 'http://www.goodogs.com' }, { name: 'audion', image: 'static/images/projects/audion.jpg', caption: 'AudioClinic Nataly', desc: 'Website', link: 'http://www.audion.co.il' }]
			};
		}
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'team',
		data: function data() {
			return {};
		}
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _viewPortfolio = __webpack_require__(1);
	
	var _viewPortfolio2 = _interopRequireDefault(_viewPortfolio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'technologies',
		components: {
			viewPortfolio: _viewPortfolio2.default
		},
		data: function data() {
			return {
				currentPage: 0,
				itemsPerPage: 8,
				technologies: [{ name: 'vuejs', image: 'static/images/tech/vuejs.jpg', caption: 'Vue.js', desc: 'JS Framework' }, { name: 'Webpack', image: 'static/images/tech/webpack.jpg', caption: 'Webpack', desc: 'Module bundler' }, { name: 'angular2', image: 'static/images/tech/angular2.jpg', caption: 'Angular 2.0', desc: 'JS Framework' }, { name: 'redux', image: 'static/images/tech/redux.jpg', caption: 'Redux', desc: 'State management' }, { name: 'git', image: 'static/images/tech/git.jpg', caption: 'Git', desc: ' Version Control' }, { name: 'jasmine', image: 'static/images/tech/jasmine.jpg', caption: 'Jasmine', desc: 'JS Testing Framework' }, { name: 'restdbio', image: 'static/images/tech/restdbio.jpg', caption: 'restdb.io', desc: 'mongoDB REST API' }, { name: 'nodejs', image: 'static/images/tech/nodejs.jpg', caption: 'Node.js', desc: 'Server-Side JS' }, { name: 'html5', image: 'static/images/tech/html5.jpg', caption: 'HTML5', desc: 'Latest standard' }, { name: 'Webcomponents', image: 'static/images/tech/webcomp.jpg', caption: 'Web Components', desc: 'Reusable web parts' }, { name: 'babel', image: 'static/images/tech/babel.jpg', caption: 'Babel', desc: 'ES6/7 Compiler' }, { name: 'react', image: 'static/images/tech/react.jpg', caption: 'React', desc: 'JS Framework' }, { name: 'polymer', image: 'static/images/tech/polymer.jpg', caption: 'Polymer', desc: 'JS Framework' }, { name: 'npm', image: 'static/images/tech/npm.jpg', caption: 'NPM', desc: 'Package Manager' }, { name: 'bower', image: 'static/images/tech/bower.jpg', caption: 'Bower', desc: 'Package Manager' }, { name: 'grunt', image: 'static/images/tech/grunt.jpg', caption: 'Grunt', desc: 'JS Task Runner' }, { name: 'gulp', image: 'static/images/tech/gulp.jpg', caption: 'Gulp', desc: 'JS Task Runner' }]
			};
		}
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'viewPorfolio',
		props: ['data', 'itemsPerPage'],
		computed: {
			totalPages: function totalPages() {
				return Math.ceil(this.resultCount / this.itemsPerPage);
			}
		},
		methods: {
			setPage: function setPage(pageNumber) {
				if (pageNumber >= 0 && pageNumber <= this.totalPages) {
					this.currentPage = pageNumber;
				}
			},
			paginate: function paginate(list) {
				this.resultCount = list.length;
				if (this.currentPage >= this.totalPages) {
					this.currentPage = this.totalPages - 1;
				}
				var index = this.currentPage * this.itemsPerPage;
				return list.slice(index, index + this.itemsPerPage);
			}
		},
		data: function data() {
			return {
				currentPage: 0,
				resultCount: 0
			};
		}
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		name: 'websiteDevelopment',
		methods: {
			toggleCollapse: function toggleCollapse(collapse) {
				if (collapse) {
					this[collapse] = !this[collapse];
				}
			}
		},
		data: function data() {
			return {
				collapseA: false,
				collapseB: false,
				collapseC: false
			};
		}
	};

/***/ },
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 21 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 22 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 23 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 24 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 25 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 26 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 27 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 28 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 29 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 30 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 31 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 32 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(21)
	
	/* script */
	__vue_exports__ = __webpack_require__(4)
	
	/* template */
	var __vue_template__ = __webpack_require__(46)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(23)
	
	/* script */
	__vue_exports__ = __webpack_require__(5)
	
	/* template */
	var __vue_template__ = __webpack_require__(48)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-29829f05"
	
	module.exports = __vue_exports__


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(27)
	
	/* script */
	__vue_exports__ = __webpack_require__(6)
	
	/* template */
	var __vue_template__ = __webpack_require__(52)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-4ab502f7"
	
	module.exports = __vue_exports__


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(30)
	
	/* script */
	__vue_exports__ = __webpack_require__(7)
	
	/* template */
	var __vue_template__ = __webpack_require__(55)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a108843c"
	
	module.exports = __vue_exports__


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(29)
	
	/* script */
	__vue_exports__ = __webpack_require__(8)
	
	/* template */
	var __vue_template__ = __webpack_require__(54)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-5e535ef2"
	
	module.exports = __vue_exports__


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(24)
	
	/* script */
	__vue_exports__ = __webpack_require__(9)
	
	/* template */
	var __vue_template__ = __webpack_require__(49)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-31fd8af8"
	
	module.exports = __vue_exports__


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(31)
	
	/* script */
	__vue_exports__ = __webpack_require__(10)
	
	/* template */
	var __vue_template__ = __webpack_require__(56)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-a72c53b0"
	
	module.exports = __vue_exports__


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(22)
	
	/* script */
	__vue_exports__ = __webpack_require__(11)
	
	/* template */
	var __vue_template__ = __webpack_require__(47)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-156c5a20"
	
	module.exports = __vue_exports__


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(25)
	
	/* script */
	__vue_exports__ = __webpack_require__(12)
	
	/* template */
	var __vue_template__ = __webpack_require__(50)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-37f00600"
	
	module.exports = __vue_exports__


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(28)
	
	/* script */
	__vue_exports__ = __webpack_require__(13)
	
	/* template */
	var __vue_template__ = __webpack_require__(53)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-57b9b8e0"
	
	module.exports = __vue_exports__


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(20)
	
	/* script */
	__vue_exports__ = __webpack_require__(14)
	
	/* template */
	var __vue_template__ = __webpack_require__(45)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0984b200"
	
	module.exports = __vue_exports__


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(32)
	
	/* script */
	__vue_exports__ = __webpack_require__(16)
	
	/* template */
	var __vue_template__ = __webpack_require__(57)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-c2b6b7cc"
	
	module.exports = __vue_exports__


/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "expertise"
	  }, [_c('h1', [_vm._v("Technologies We Use")]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_vm._m(0), _vm._v(" "), _c('view-portfolio', {
	    attrs: {
	      "data": _vm.technologies,
	      "itemsPerPage": _vm.itemsPerPage
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n\t\t\tOnly having one tool to work with limits what you can achieve."), _c('br'), _vm._v("\n\t\t\tThat's why we believe a web-developer should have a whole toolbox of knowledge.\n\t\t")])
	}]}

/***/ },
/* 46 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "app",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('app-header', {
	    attrs: {
	      "name": _vm.companyName,
	      "desc": _vm.companyDesc
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "cover"
	  }), _vm._v(" "), _c('main', {
	    staticClass: "app-view"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('app-sidebar'), _vm._v(" "), _c('div', {
	    staticClass: "app-content col-md-9"
	  }, [_c('router-view', {
	    staticClass: "view"
	  })], 1)], 1)]), _vm._v(" "), _c('app-footer', {
	    attrs: {
	      "name": _vm.companyName,
	      "desc": _vm.companyDesc
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "home"
	  }, [_c('div', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "jumbo jumbo-a"
	  }, [_c('div', {
	    staticClass: "jumbo-content"
	  }, [_c('h2', {
	    staticClass: "text-uppercase"
	  }, [_vm._v("Website Development")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-default btn-lg text-uppercase",
	    attrs: {
	      "to": "website-development"
	    }
	  }, [_vm._v("Read more")]), _vm._v(" "), _c('p', [_vm._v("We provide customized web-based solutions tailored to the client’s specific business requirements using the latest technologies and industry trends.")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "jumbo jumbo-b"
	  }, [_c('div', {
	    staticClass: "jumbo-content"
	  }, [_c('h2', {
	    staticClass: "text-uppercase"
	  }, [_vm._v("Front-End Outsourcing")]), _vm._v(" "), _c('router-link', {
	    staticClass: "btn btn-default btn-lg text-uppercase",
	    attrs: {
	      "to": "front-end-outsourcing"
	    }
	  }, [_vm._v("Read more")]), _vm._v(" "), _c('p', [_vm._v("While you focus on your core business process, our expert web developers will maximize your ability to deliver high quality product and speed up time-to-market.")])], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "app-footer"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "small"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-copyright-mark"
	  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.name))]), _vm._v(" " + _vm._s(_vm.desc) + " |\n\t\t\t"), _vm._m(0), _vm._v(" |\n\t\t\t"), _vm._m(1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "tel:+972525865589",
	      "title": "Reach us by phone"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-earphone"
	  }), _vm._v(" (972) 52-5865589")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "mailto:info@weboko.co.il",
	      "title": "Write us an E-mail"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-envelope"
	  }), _vm._v(" E-Mail Us")])
	}]}

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "contactus"
	  }, [_c('h1', [_vm._v("Let's Work Together")]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('p', [_vm._v("We look forward to hearing from you")]), _vm._v(" "), _c('ul', {
	    staticClass: "media-list contactus-list"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', {
	    staticClass: "media media-success"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Fill out form")]), _vm._v(" "), (!_vm.mail.thankyou) ? _c('div', {
	    staticClass: "contact-form"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mail.name),
	      expression: "mail.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "name",
	      "data-type": "text",
	      "type": "text",
	      "placeholder": "Name",
	      "required": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.mail.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mail.name = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mail.phone),
	      expression: "mail.phone"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "phone",
	      "data-type": "text",
	      "type": "text",
	      "placeholder": "Phone",
	      "required": ""
	    },
	    domProps: {
	      "value": _vm._s(_vm.mail.phone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mail.phone = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mail.email),
	      expression: "mail.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "data-type": "email",
	      "type": "email",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": _vm._s(_vm.mail.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mail.email = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mail.message),
	      expression: "mail.message"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "input",
	      "data-type": "text",
	      "type": "text",
	      "placeholder": "Message"
	    },
	    domProps: {
	      "value": _vm._s(_vm.mail.message)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mail.message = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "id": "btn-submit"
	    },
	    on: {
	      "click": _vm.submitForm
	    }
	  }, [_vm._v("Submit")])]) : _vm._e(), _vm._v(" "), (_vm.mail.thankyou) ? _c('div', {
	    staticClass: "thankyou"
	  }, [_vm._v("\n\t\t\t\t\t\tThank you!"), _c('br'), _vm._v("\n\t\t\t\t\t\tYour message has been successfully sent. We will contact you very soon!\n\t\t\t\t\t")]) : _vm._e()])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "media media-success"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-circle",
	    attrs: {
	      "href": "tel:+972525865589"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-circle",
	    attrs: {
	      "src": "static/images/icons/mobileW.png",
	      "alt": "phone"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Reach us by phone")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "tel:+972525865589"
	    }
	  }, [_vm._v("(972) 52-5865589")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "media media-success"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-circle",
	    attrs: {
	      "href": "mailto:info@weboko.co.il"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-circle",
	    attrs: {
	      "src": "static/images/icons/emailW.png",
	      "alt": "email"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Write us an e-mail")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "mailto:info@weboko.co.il"
	    }
	  }, [_vm._v("info@weboko.co.il")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-circle",
	    attrs: {
	      "href": "mailto:info@weboko.co.il"
	    }
	  }, [_c('img', {
	    staticClass: "media-object img-circle",
	    attrs: {
	      "src": "static/images/icons/chatW.png",
	      "alt": "email"
	    }
	  })])])
	}]}

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "expertise"
	  }, [_c('h1', [_vm._v("Projects")]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('view-portfolio', {
	    attrs: {
	      "data": _vm.projects,
	      "itemsPerPage": _vm.itemsPerPage
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "view-portfolio",
	    attrs: {
	      "ng-if": "data && data.length"
	    }
	  }, [_c('ul', {
	    staticClass: "portfolio-list clearfix"
	  }, _vm._l((_vm.paginate(_vm.data)), function(item) {
	    return _c('li', {
	      staticClass: "item",
	      attrs: {
	        "id": item.name
	      }
	    }, [_c('img', {
	      staticClass: "item-img",
	      attrs: {
	        "src": item.image
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "item-data"
	    }, [_c('h4', {
	      staticClass: "item-caption"
	    }, [_vm._v(_vm._s(item.caption))]), _vm._v(" "), _c('div', {
	      staticClass: "item-desc"
	    }, [_vm._v(_vm._s(item.desc))]), _vm._v(" "), (item.link) ? _c('a', {
	      staticClass: "item-desc",
	      attrs: {
	        "href": item.link,
	        "target": "_blank"
	      }
	    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.linkCaption || 'Open in new window') + " "), _c('span', {
	      staticClass: "glyphicon glyphicon-new-window"
	    })]) : _vm._e()])])
	  })), _vm._v(" "), _c('nav', {
	    attrs: {
	      "aria-label": "Page navigation"
	    }
	  }, [_c('ul', {
	    staticClass: "pagination"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "aria-label": "Previous"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setPage(_vm.currentPage - 1)
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("«")])])]), _vm._v(" "), _vm._l((_vm.totalPages), function(pageNumber) {
	    return _c('li', [_c('a', {
	      class: {
	        current: _vm.currentPage === pageNumber - 1
	      },
	      on: {
	        "click": function($event) {
	          _vm.setPage(pageNumber - 1)
	        }
	      }
	    }, [_vm._v(_vm._s(pageNumber))])])
	  }), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "aria-label": "Next"
	    },
	    on: {
	      "click": function($event) {
	        _vm.setPage(_vm.currentPage + 1)
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("»")])])])], 2)])])
	},staticRenderFns: []}

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "app-header"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', [_vm._v("{ " + _vm._s(_vm.name) + " "), _c('span', [_vm._v(_vm._s(_vm.desc))]), _vm._v(" }")])])])
	},staticRenderFns: []}

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "team"
	  }, [_c('h1', [_vm._v("Meet the Team")]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('p', [_vm._v("\n\t\t\tIf you are looking for reliable and expert web development services then you are in the right place.\n\t\t\tOur expert team of web developers are ready to work together.\n\t\t\t")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_c('small', [_vm._v("Want to join our team? Visit our "), _c('router-link', {
	    attrs: {
	      "to": "careers"
	    }
	  }, [_vm._v("careers page")]), _vm._v(" for more details!")], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "media-list team-list"
	  }, [_c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('img', {
	    staticClass: "media-object",
	    attrs: {
	      "src": "static/images/team/chen.jpg",
	      "alt": "Web Development and Consulting"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Chen Koifman")]), _vm._v("\n\t\t\t\t\tFounder & Leader Web Developer\n\t\t\t\t\t"), _c('p', [_c('small', [_vm._v("\n\t\t\t\t\t\t\tOver 15 years of experience as a leader web developer/JS expert."), _c('br'), _vm._v("\n\t\t\t\t\t\t\tIn his resume some of the world's most influential organizations (SAP, Nice, AVG, Cellebrite) and Israeli leading companies (Migdal, Wallashops, Sela, Code Oasis)."), _c('br'), _vm._v("\n\t\t\t\t\t\t\tMy expertise is focused on web development using: Angular, Redux, Node.js, Express, Vue.js, Webpack, ES6 and more...\n\t\t\t\t\t\t")])])])])])
	}]}

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "careers"
	  }, [_c('h1', [_vm._v("Join Our Team")]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('p', [_vm._v("\n\t\t\tThank you for your interest in Weboko. There are currently no positions available."), _c('br'), _vm._v("\n\t\t\tPlease visit our site again for future job postings that may relate to your experience and talents.\n\t\t")])])])
	}]}

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', {
	    staticClass: "app-sidebar col-md-3"
	  }, [_c('nav', {
	    staticClass: "app-nav"
	  }, [_c('ul', {
	    staticClass: "nav"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "home"
	    }
	  }, [_vm._v("What We Do")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "website-development"
	    }
	  }, [_vm._v("Website Development")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "front-end-outsourcing"
	    }
	  }, [_vm._v("Front End Outsourcing")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "technologies"
	    }
	  }, [_vm._v("Technologies We Use")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "team"
	    }
	  }, [_vm._v("Who We Are")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": "contactus"
	    }
	  }, [_vm._v("Contact Us")])], 1)])]), _vm._v(" "), (_vm.$route && _vm.$route.name && _vm.$route.name !== 'contactus') ? _c('router-link', {
	    staticClass: "btn btn-success btn-block btn-lg text-uppercase hireus",
	    attrs: {
	      "to": "contactus"
	    }
	  }, [_vm._v("\n\t\tHire Us "), _c('span', {
	    staticClass: "glyphicon glyphicon-chevron-right"
	  })]) : _vm._e(), _vm._v(" "), (_vm.$route && _vm.$route.name !== 'home') ? _c('div', {
	    staticClass: "tag-cloud"
	  }, [_c('h4', [_vm._v("Popular Tags:")]), _vm._v(" "), _vm._l((_vm.tags), function(tag) {
	    return _c('router-link', {
	      staticClass: "btn btn-default btn-xs",
	      attrs: {
	        "to": tag.link
	      }
	    }, [_vm._v(_vm._s(tag.name))])
	  })], 2) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "fed-os"
	  }, [_c('h1', [_vm._v("Front End Outsourcing")]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('p', [_vm._v("\n\t\t\tWhile you focus on your core business process, our expert web developers will maximize your ability to deliver high quality product and speed up time-to-market.\n\t\t")]), _vm._v(" "), _c('h3', {
	    staticClass: "collapse-link",
	    on: {
	      "click": function($event) {
	        _vm.toggleCollapse('collapseA')
	      }
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.collapseA),
	      expression: "!collapseA"
	    }],
	    staticClass: "glyphicon glyphicon-chevron-right"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.collapseA),
	      expression: "collapseA"
	    }],
	    staticClass: "glyphicon glyphicon-chevron-down"
	  }), _vm._v("\n\t\t\tWhy outsource your web development\n\t\t")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.collapseA),
	      expression: "collapseA"
	    }],
	    staticClass: "collapse-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "spacing10"
	  }), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tOutsourcing web development makes a lot of sense in order to maximize your profits in a small amount of time.\n\t\t\t")]), _vm._v(" "), _c('div', {
	    staticClass: "spacing30"
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "media-list icon-list"
	  }, [_c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-euro"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Cost Savings.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-hourglass"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Time Savings.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-resize-horizontal"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Flexibility.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-record"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Focused Strategy.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-ok"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Lack of in house experience.")])])])])
	}]}

/***/ },
/* 57 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "website-dev"
	  }, [_c('h1', [_vm._v("Website Development")]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_c('p', [_vm._v("\n\t\t\tWe provide customized web-based solutions tailored to the client’s specific business requirements using the latest technologies and industry trends.\n\t\t")]), _vm._v(" "), _c('h3', {
	    staticClass: "collapse-link",
	    on: {
	      "click": function($event) {
	        _vm.toggleCollapse('collapseA')
	      }
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.collapseA),
	      expression: "!collapseA"
	    }],
	    staticClass: "glyphicon glyphicon-chevron-right"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.collapseA),
	      expression: "collapseA"
	    }],
	    staticClass: "glyphicon glyphicon-chevron-down"
	  }), _vm._v("\n\t\t\tWhy a Website is a worthwhile business investment\n\t\t")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.collapseA),
	      expression: "collapseA"
	    }],
	    staticClass: "collapse-container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "spacing10"
	  }), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tLet us help you develop an efficient website solution for your business.\n\t\t\t")]), _vm._v(" "), _c('div', {
	    staticClass: "spacing30"
	  })]), _vm._v(" "), _c('h3', {
	    staticClass: "collapse-link",
	    on: {
	      "click": function($event) {
	        _vm.toggleCollapse('collapseB')
	      }
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.collapseB),
	      expression: "!collapseB"
	    }],
	    staticClass: "glyphicon glyphicon-chevron-right"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.collapseB),
	      expression: "collapseB"
	    }],
	    staticClass: "glyphicon glyphicon-chevron-down"
	  }), _vm._v("\n\t\t\tWebsite Development Process\n\t\t")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.collapseB),
	      expression: "collapseB"
	    }],
	    staticClass: "collapse-container"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "spacing10"
	  }), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tWe deliver fast and effective website solutions.\n\t\t\t")]), _vm._v(" "), _c('div', {
	    staticClass: "spacing30"
	  })]), _vm._v(" "), _c('h3', {
	    staticClass: "collapse-link",
	    on: {
	      "click": function($event) {
	        _vm.toggleCollapse('collapseC')
	      }
	    }
	  }, [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.collapseC),
	      expression: "!collapseC"
	    }],
	    staticClass: "glyphicon glyphicon-chevron-right"
	  }), _vm._v(" "), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.collapseC),
	      expression: "collapseC"
	    }],
	    staticClass: "glyphicon glyphicon-chevron-down"
	  }), _vm._v("\n\t\t\tWhy our websites are the right solution for you\n\t\t")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.collapseC),
	      expression: "collapseC"
	    }],
	    staticClass: "collapse-container"
	  }, [_vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "spacing10"
	  }), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tWe makes websites that are simple to update and customized for each client’s specific needs.\n\t\t\t")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "media-list icon-list"
	  }, [_c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon glyphicon-globe"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Reach a wider audience regardless of geographical location.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-sunglasses"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Creates a professional look for your brand.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-repeat"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Saves you time answering the same questions over and over again.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-time"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Accessible around the clock 24/7.")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "media-list icon-list"
	  }, [_c('li', {
	    staticClass: "media media-primary media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-primary-invert btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "customicon"
	  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Information Gathering")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Purpose")]), _c('li', [_vm._v("Goals")]), _vm._v(" "), _c('li', [_vm._v("Target Audience")]), _vm._v(" "), _c('li', [_vm._v("Content")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-primary media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-primary-invert btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "customicon"
	  }, [_vm._v("2")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Planning")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Research")]), _vm._v(" "), _c('li', [_vm._v("Analyze")]), _vm._v(" "), _c('li', [_vm._v("Technologies")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-primary media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-primary-invert btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "customicon"
	  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Design")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Look and Feel")]), _vm._v(" "), _c('li', [_vm._v("Responsive Design")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-primary media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-primary-invert btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "customicon"
	  }, [_vm._v("4")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Development")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Custom Web Development")]), _vm._v(" "), _c('li', [_vm._v("CMS (Content Management System)")]), _vm._v(" "), _c('li', [_vm._v("Documentation")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-primary media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-primary-invert btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "customicon"
	  }, [_vm._v("5")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Testing")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("General Testing")]), _vm._v(" "), _c('li', [_vm._v("Usability Testing")]), _vm._v(" "), _c('li', [_vm._v("Performance Profiling")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-primary media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-primary-invert btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "customicon"
	  }, [_vm._v("6")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Acceptance and Deployment")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Review and Approval")]), _vm._v(" "), _c('li', [_vm._v("Launch")])])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-primary media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-primary-invert btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "customicon"
	  }, [_vm._v("7")])])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Maintenance")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Management")]), _vm._v(" "), _c('li', [_vm._v("SEO (Search Engine Optimization)")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "media-list icon-list"
	  }, [_c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-user"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("User Friendly.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-cog"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Easily Manageable.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-search"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Search Engine Friendly.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-phone"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Responsive with a multi-device friendly approach.")])])]), _vm._v(" "), _c('li', {
	    staticClass: "media media-success media-default"
	  }, [_c('div', {
	    staticClass: "media-left"
	  }, [_c('a', {
	    staticClass: "btn btn-success btn-lg btn-circle"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-heart"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "media-body"
	  }, [_c('h4', {
	    staticClass: "media-heading"
	  }, [_vm._v("Customized to the client’s specific needs.")])])])])
	}]}

/***/ },
/* 58 */,
/* 59 */,
/* 60 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.4ca414f2e4b3efda1f89.js